import { Flex } from '@chakra-ui/react';
import React from 'react';

import { CmBox, CmStack, CmText } from '@/components/uiParts';
import { EllipsesButton } from '@/components/uiParts/Button/EllipsesButton';
import { errorHandler } from '@/lib/ErrorHandler';
import { HttpError } from '@/lib/exception';
import { SidebarWrapper } from '@/pages/store-management/components/Layout/SidebarWrapper';
import { useStoreManagementAssociateBrandDelete } from '@/services/StoreManagement/AssociateBrands/hooks/delete/useStoreManagementAssociateBrandDelete';
import { StoreManagementBrandSearchList } from '@/services/StoreManagement/Brands/hooks';
type Props = {
  isSidebarOpen: boolean;
  targetBrand?: StoreManagementBrandSearchList;
  handleCloseSidebar: () => void;
  handleInitializeBrands: () => Promise<void>;
};

export const BrandSidebarForm: React.FC<Props> = ({
  isSidebarOpen,
  targetBrand,
  handleCloseSidebar,
  handleInitializeBrands,
}) => {
  const handleDelete = async () => {
    const checkDelete = confirm(`${targetBrand?.name}を削除しますか？`);
    if (!checkDelete) {
      return;
    }

    try {
      if (!targetBrand) {
        return;
      }
      await useStoreManagementAssociateBrandDelete(targetBrand.id.toString());
      alert('ブランドを削除しました。');
      await handleInitializeBrands();
      handleCloseSidebar();
    } catch (error) {
      if (error instanceof HttpError && error.status === 400) {
        return alert(error.message);
      }
      // @ts-ignore TS2322
      errorHandler({ error });
    }
  };

  return (
    <SidebarWrapper
      {...{
        isSidebarOpen,
        handleCloseSidebar,
        buttonComponent: (
          <Flex>
            <EllipsesButton
              menus={[
                {
                  label: '削除',
                  menuItemProps: {
                    _hover: { bg: 'rgba(0, 0, 0, 0.06)' },
                    onClick: handleDelete,
                    fontWeight: 'bold',
                    color: 'red',
                  },
                },
              ]}
              menuButtonProps={{
                _hover: { bg: 'rgba(0, 0, 0, 0.06)' },
                padding: '5px 10px',
              }}
            />
          </Flex>
        ),
      }}
    >
      <CmBox>
        <CmStack spacing="5px">
          <CmText fontSize="md" fontWeight="bold">
            ブランド名
          </CmText>
          <CmText fontSize="md">{targetBrand?.name}</CmText>
        </CmStack>
      </CmBox>
    </SidebarWrapper>
  );
};
